
import { useState } from 'react';
import { useEmail } from '@/context/EmailContext';
import { toast } from '@/hooks/use-toast';

export const useEmailFolderActions = () => {
  const { 
    markAsRead, 
    markAsUnread, 
    moveToFolder,
    permanentlyDeleteEmail,
    refreshEmails
  } = useEmail();
  
  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);

  const handleMarkAsRead = async () => {
    for (const id of selectedEmails) {
      await markAsRead(id);
    }
    toast.success(`Marked ${selectedEmails.length} ${selectedEmails.length === 1 ? 'email' : 'emails'} as read`);
    setSelectedEmails([]);
  };

  const handleMarkAsUnread = async () => {
    for (const id of selectedEmails) {
      await markAsUnread(id);
    }
    toast.success(`Marked ${selectedEmails.length} ${selectedEmails.length === 1 ? 'email' : 'emails'} as unread`);
    setSelectedEmails([]);
  };

  const handleMoveToTrash = async () => {
    const count = selectedEmails.length;
    for (const id of selectedEmails) {
      await moveToFolder(id, 'trash');
    }
    toast.success(`Moved ${count} ${count === 1 ? 'email' : 'emails'} to trash`);
    setSelectedEmails([]);
  };

  const handleDelete = async (currentFolder: string) => {
    const count = selectedEmails.length;
    if (count === 0) return;

    try {
      if (currentFolder === 'trash') {
        for (const id of selectedEmails) {
          await permanentlyDeleteEmail(id);
        }
        toast.success(`Permanently deleted ${count} ${count === 1 ? 'email' : 'emails'}`);
      } else {
        for (const id of selectedEmails) {
          const movedEmail = await moveToFolder(id, 'trash');
          if (!movedEmail) {
            throw new Error('The server did not move the selected email');
          }
        }
        toast.success(`Moved ${count} ${count === 1 ? 'email' : 'emails'} to trash`);
      }

      setSelectedEmails([]);
      await refreshEmails();
    } catch (error) {
      console.error('Failed to delete selected emails:', error);
      toast.error('Delete failed. Please try again.');
    }
  };

  const handleRefresh = async () => {
    await refreshEmails();
  };

  return {
    selectedEmails,
    setSelectedEmails,
    handleMarkAsRead,
    handleMarkAsUnread,
    handleMoveToTrash,
    handleDelete,
    handleRefresh
  };
};
